/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

export type V1ProjectsCreateProjectRequestBody = {
  /**
   * Human-readable name for this project.
   *
   * @remarks
   * Use a descriptive name like 'Payments Service' to identify its purpose.
   */
  name: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  slug: string;
};

/** @internal */
export type V1ProjectsCreateProjectRequestBody$Outbound = {
  name: string;
  slug: string;
};

/** @internal */
export const V1ProjectsCreateProjectRequestBody$outboundSchema: z.ZodType<
  V1ProjectsCreateProjectRequestBody$Outbound,
  z.ZodTypeDef,
  V1ProjectsCreateProjectRequestBody
> = z.object({
  name: z.string(),
  slug: z.string(),
});

export function v1ProjectsCreateProjectRequestBodyToJSON(
  v1ProjectsCreateProjectRequestBody: V1ProjectsCreateProjectRequestBody,
): string {
  return JSON.stringify(
    V1ProjectsCreateProjectRequestBody$outboundSchema.parse(
      v1ProjectsCreateProjectRequestBody,
    ),
  );
}
